import { el } from './dom.js';

/**
 * 部屋ごとの視点切り替えバー。
 * 自由移動だけだと内見者が確実に迷うため、これが実質の主操作になる。
 */
export function createViewpointBar(container, viewpoints, onSelect) {
  let activeIndex = 0;

  const buttons = viewpoints.map((vp, index) =>
    el(
      'button',
      {
        class: 'vp-btn',
        type: 'button',
        onClick: () => {
          select(index);
          onSelect(vp, index);
        },
      },
      vp.name,
    ),
  );

  function select(index) {
    activeIndex = index;
    buttons.forEach((btn, i) => btn.classList.toggle('is-active', i === index));
  }
  select(0);

  const root = el('nav', { class: 'vp-bar', 'aria-label': '部屋を選ぶ' }, buttons);
  container.appendChild(root);

  return { select, get activeIndex() { return activeIndex; } };
}
